
export const jobTypeList = "JOB_TYPE_LIST";